import React from "react";
import Icon from "../../../components/AppIcon";

const OfficeSection = () => {
  const officeDetails = {
    location: "Orator Hype PVT LTD.",
    address:
      "Office No.3 Ground Floor, Kanji Moraji BlDG, ORATOR HYPE PVT.LTD, 9, Keshavji Naik Rd, Mumbai, Maharashtra 400009",

    coordinates: {
      lat: 18.955444,
      lng: 72.837722,
    },

    features: [
      {
        icon: "Building2",
        title: "Modern Infrastructure",
        description: "State-of-the-art office space with latest technology",
      },
      {
        icon: "Users",
        title: "Collaborative Spaces",
        description: "Open work areas designed for team collaboration",
      },
      {
        icon: "Coffee",
        title: "Creative Zones",
        description: "Dedicated spaces for brainstorming and innovation",
      },
      {
        icon: "Shield",
        title: "Secure Environment",
        description: "Enterprise-grade security and data protection",
      },
    ],

    workCulture: [
      "Flexible work arrangements with hybrid options",
      "Regular team building and cultural events",
      "Continuous learning and development programs",
      "Health and wellness initiatives",
      "Work-life balance emphasis",
      "Innovation-driven environment",
      "Community engagement activities",
    ],
  };

  return (
    <section className="relative bg-gradient-to-br from-[#2642B2] via-indigo-900 to-slate-900 text-white py-12 md:py-16 lg:py-20 px-4 md:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        {/* HEADER */}
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 bg-white/10 px-4 py-2 rounded-full mb-4 border border-white/20">
            <Icon name="MapPin" size={18} className="text-cyan-400" />
            <span className="text-sm font-medium">Our Office</span>
          </div>

          <h2 className="text-3xl lg:text-4xl font-bold mb-4">
            Visit Us in{" "}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-blue-400">
              Mumbai
            </span>
          </h2>

          <p className="text-white/80 max-w-3xl mx-auto">
            Our office is located in the heart of Mumbai's business district,
            designed to foster creativity, collaboration, and innovation.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10">
          {/* OFFICE INFO */}
          <div className="bg-white/10 backdrop-blur-md rounded-2xl p-8 border border-white/20">
            <div className="flex gap-4 mb-6">
              <div className="w-14 h-14 rounded-xl bg-gradient-to-br from-cyan-500 to-blue-600 flex items-center justify-center">
                <Icon name="MapPin" size={24} color="#fff" />
              </div>
              <div>
                <h3 className="text-xl font-bold mb-1">
                  {officeDetails.location}
                </h3>
                <p className="text-white/70">{officeDetails.address}</p>
              </div>
            </div>

            <div className="grid sm:grid-cols-2 gap-4 mb-6">
              {officeDetails.features.map((feature, index) => (
                <div
                  key={index}
                  className="flex gap-3 p-4 bg-white/5 rounded-xl hover:bg-white/10 transition"
                >
                  <div className="w-10 h-10 rounded-lg bg-cyan-500/20 flex items-center justify-center">
                    <Icon
                      name={feature.icon}
                      size={20}
                      className="text-cyan-400"
                    />
                  </div>
                  <div>
                    <h4 className="font-semibold text-sm">
                      {feature.title}
                    </h4>
                    <p className="text-xs text-white/60">
                      {feature.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>

            <div className="border-t border-white/20 pt-6 space-y-3">
              <div className="flex items-center gap-3">
                <Icon name="Phone" size={18} className="text-cyan-400" />
                <span>+91 73046 60050</span>
              </div>
              <div className="flex items-center gap-3">
                <Icon name="Mail" size={18} className="text-cyan-400" />
                <span>sales@oratorhype.com</span>
              </div>
              <div className="flex items-center gap-3">
                <Icon name="Clock" size={18} className="text-cyan-400" />
                <span>Mon–Fri: 9:00 AM – 6:00 PM IST</span>
              </div>
            </div>
          </div>

          {/* MAP */}
          <div className="relative rounded-2xl overflow-hidden border border-white/20 min-h-[400px]">
            {officeDetails.coordinates && (
              <iframe
                title="Orator Hype Office Location"
                width="100%"
                height="100%"
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                src={`https://www.google.com/maps?q=${officeDetails.coordinates.lat},${officeDetails.coordinates.lng}&z=16&output=embed`}
                className="absolute inset-0 border-0"
                allowFullScreen
              />
            )}

            <div className="absolute bottom-0 left-0 right-0 bg-black/60 p-3 text-center text-sm">
              📍 Mumbai Central, Maharashtra
            </div>
          </div>
        </div>

        {/* WORK CULTURE */}
        <div className="mt-16 bg-white/10 backdrop-blur-xl rounded-3xl p-8 border border-white/20">
          <h3 className="text-2xl font-bold mb-6 text-center">
            Our Work{" "}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-blue-400">
              Culture
            </span>
          </h3>

          <div className="grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
            {officeDetails.workCulture.map((item, index) => (
              <div
                key={index}
                className="flex gap-3 p-4 bg-white/5 rounded-xl hover:bg-white/10 transition"
              >
                <Icon
                  name="CheckCircle"
                  size={18}
                  className="text-cyan-400"
                />
                <span className="text-sm">{item}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default OfficeSection;
